<template>
    <div
        :class="`products-layered-image-${id}`"
    >
        <div
            v-if="isLoadingGlobal"
            class="w-100 h-100 position-absolute z-index-1"
        >
            <div
                class="fit-a-min-content rounded-circle absolute-center"
            >
                <v-progress-circular
                    color="accent"
                    indeterminate
                ></v-progress-circular>

            </div>

        </div>
        <ProductsImage
            :image-object="imageObject"
            :loading="index ? 'lazy' : 'eager'"
            :data-is-loading-on-start="isLoadingOnStart"
            @on-load-start="onStart(`main-${id}`)"
            @on-load-end="onEnd(`main-${id}`)"
            @on-load-error="onError(`main-${id}`)"
            v-bind="topImageProps"
            :class="`layered-img-top-${imageObject.uid}`"
        ></ProductsImage>
        <template
            v-if="imageStack?.size && imageObject?.groupKey && imageStack.has(imageObject.groupKey)"
        >
            <div
                v-for="(item, index2) in imageStack.get(imageObject.groupKey)"
                :key="`stack-item-${item.uid}`"
                v-bind="lowImagesContainerProps"
                :class="`layered-img-low-${id} absolute-left`"
            >
                <ProductsImage
                    @on-load-start="onStart(`low-${id}`)"
                    @on-load-end="onEnd(`low-${id}`)"
                    @on-load-error="onError(`low-${id}`)"
                    @vue:mounted="onLayerImageMounted(item)"
                    v-bind="lowImagesProps"
                    :image-object="item"
                    :loading="index2 ? 'lazy' : 'eager'"
                ></ProductsImage>
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import type {
        FullImage,
        FullImageStack
    } from '~/types';
    import { useIsLoading } from 'x1-base/composables';

    import ProductsImage from '~/components/products/ProductsImage/ProductsImage.vue';

    const props = withDefaults(
        defineProps<{
            index?: number;
            imageObject: FullImage;
            imageStack?: Nilish<FullImageStack>;
            topImageProps?: Record<string, unknown>;
            lowImagesContainerProps?: Record<string, unknown>;
            lowImagesProps?: Record<string, unknown>;
            disableLoadingIndicator?: boolean;
        }>(),
        {
            index: 0,
            topImageProps: () => ({}),
            lowImagesContainerProps: () => ({}),
            lowImagesProps: () => ({})
        }
    );

    const {
        isLoading,
        on: isLoadingOn,
        off: isLoadingOff,
        clear: isLoadingClear,
        tracked
    } = useIsLoading();

    const isLoadingOnStart = ref<boolean>(!props.disableLoadingIndicator);
    const isLoadingGlobal = computed<boolean>(() => isLoading.value || isLoadingOnStart.value);

    const id = useId();

    function onStart(id: string): void {
        if (props.disableLoadingIndicator) return;
        isLoadingOn(id);
    }

    function onEnd(id: string): void {
        if (props.disableLoadingIndicator) return;
        isLoadingOff(id);
    }

    function onError(id: string): void {
        if (props.disableLoadingIndicator) return;
        isLoadingOff(id);
    }

    function onLayerImageMounted(item: FullImage): void {
        isLoadingOnStart.value = false;
    }

    onMounted(() => {
        if (props.imageObject.url) {
            isLoadingOnStart.value = false;
        }
    });

    onBeforeUnmount(() => {
        isLoadingClear();
    });
</script>

<style lang="scss"></style>
